module.exports = __webpack_public_path__ + "34736292/img/file-icon.c085e21e.svg";